import { post } from '@creator/sdk/network/api-service';
import { getFirebaseProjectId } from '@src/config';
import { useStoreState } from '@src/model/hooks';
import { getMyUser } from '@src/model/user/helpers';
import { usePost } from '@src/store/posts/hooks/usePost';
import { type FC, useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router';

interface NetworkAdminDebugInfoProps {
    className?: string;
    currentTab?: string;
    tokenName?: string;
}

const NetworkAdminDebugInfo: FC<NetworkAdminDebugInfoProps> = ({ className = '', currentTab, tokenName: propTokenName }) => {
    const location = useLocation();
    const params = useParams();
    const isLoggedIn = useStoreState(state => state.user.isLoggedIn);
    const myUser = getMyUser();

    // Check if user is network admin
    const isNetworkAdmin = useMemo(() => {
        return isLoggedIn && myUser?.networkAdmin === true;
    }, [isLoggedIn, myUser]);

    const firebaseProjectId = getFirebaseProjectId();

    // useEffect(() => {
    //     console.log('[NetworkAdmin] Post Debug Info:', {
    //         type: 'post',
    //         postId: pageInfo.type,
    //         slug: post.slugUrl || 'N/A',
    //         firestoreUrl: `https://console.firebase.google.com/project/${firebaseProjectId}/firestore/data/${pageInfo?.type}/${post?.id}`,
    //         tokenName: pageInfo.tokenName,
    //         pathname: location.pathname,
    //     });
    // }, [pageInfo, post, location.pathname]);

    // Don't render if user is not network admin
    if (!isNetworkAdmin) return null;

    return null;
};

export default NetworkAdminDebugInfo;
